var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopycontent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "content_copy_FILL0_wght400_GRAD0_opsz24 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.875 21.75C10.2104 21.75 9.64149 21.5133 9.16823 21.0401C8.69496 20.5668 8.45833 19.9979 8.45833 19.3333V4.83329C8.45833 4.16871 8.69496 3.59979 9.16823 3.12652C9.64149 2.65326 10.2104 2.41663 10.875 2.41663H21.75C22.4146 2.41663 22.9835 2.65326 23.4568 3.12652C23.93 3.59979 24.1667 4.16871 24.1667 4.83329V19.3333C24.1667 19.9979 23.93 20.5668 23.4568 21.0401C22.9835 21.5133 22.4146 21.75 21.75 21.75H10.875ZM10.875 19.3333H21.75V4.83329H10.875V19.3333ZM6.04167 26.5833C5.37708 26.5833 4.80816 26.3467 4.3349 25.8734C3.86163 25.4001 3.625 24.8312 3.625 24.1666V7.24996H6.04167V24.1666H19.3333V26.5833H6.04167Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopycontent);
export default __webpack_public_path__ + "static/media/copycontent.019f47d51f174286acecdb1dbb4403a8.svg";
export { ForwardRef as ReactComponent };